import app from 'flarum/forum/app';
import Dropdown from 'flarum/common/components/Dropdown';
import Icon from 'flarum/common/components/Icon';
import Tooltip from 'flarum/common/components/Tooltip';
import extractText from 'flarum/common/utils/extractText';
import TextColorModal from './TextColorModal';
import TextColorPalette from './TextColorPalette';
/**
 * The composer's text colour button (see addTextColorButton.tsx): a
 * palette icon - in the selection's colour, in the rich editor - opening
 * the swatches, in a menu or, on a phone, a modal.
 */
export default class TextColorDropdown extends Dropdown {
  static initAttrs(attrs) {
    attrs.buttonClassName = 'Button Button--icon Button--link';
    attrs.menuClassName = 'TextColorDropdown-menu';
    attrs.caretIcon = '';
    attrs.accessibleToggleLabel = extractText(app.translator.trans('champis-forum.forum.text_color.button'));
    super.initAttrs(attrs);
  }
  oncreate(vnode) {
    super.oncreate(vnode);

    // Before Bootstrap's own listener (on the document) opens the menu.
    this.$().on('click', e => {
      if (app.screen() !== 'phone') return;
      e.stopPropagation();
      app.modal.show(TextColorModal, {
        current: this.attrs.current,
        withDefault: this.attrs.withDefault,
        onpick: this.attrs.onpick
      });
    });
  }

  /**
   * Its tooltip on the icon, above it - as fof/rich-text's own buttons
   * have theirs -, not Dropdown's own `tooltip`: that one goes below the
   * button (off screen, the toolbar at the bottom of the window) and, on
   * the button itself, shows while it has the focus (after a click, the
   * menu open). Gone while the menu is open, which it would cover.
   */
  getButtonContent(_children) {
    const icon = m("span", {
      className: "Button-icon",
      style: this.attrs.current ? {
        color: this.attrs.current
      } : undefined
    }, m(Icon, {
      name: "fas fa-palette"
    }));
    return [this.showing ? icon : m(Tooltip, {
      text: this.attrs.accessibleToggleLabel
    }, icon)];
  }
  getMenu(_items) {
    return m("ul", {
      className: 'Dropdown-menu dropdown-menu ' + this.attrs.menuClassName
    }, m("li", null, m(TextColorPalette, {
      current: this.attrs.current,
      withDefault: this.attrs.withDefault,
      onpick: this.attrs.onpick
    })));
  }
}
flarum.reg.add('champis-forum', 'forum/components/TextColorDropdown', TextColorDropdown);